import { useEffect, useState } from 'react';

import { getCompanyMetrics } from '../../../store/debtProducts/apiHelper_debtProducts';
import { LENDER_IP_DOC_MARKER } from '../DebtProductsConstants';

export function useLenderIpGate(lenderId?: string): boolean {
    const [hasLenderIp, setHasLenderIp] = useState(false);

    useEffect(() => {
        setHasLenderIp(false);
        if (!lenderId) return;

        let cancelled = false;

        async function checkLenderIp() {
            const result = await getCompanyMetrics({ assesseeOrgId: lenderId! }, true);
            if (cancelled) return;
            const documents: { documentName?: string }[] = result?.companyMetrics?.profile?.documents ?? [];
            setHasLenderIp(documents.some((doc) => doc.documentName?.includes(LENDER_IP_DOC_MARKER)));
        }

        checkLenderIp().catch(() => {
            if (!cancelled) setHasLenderIp(false);
        });

        return () => {
            cancelled = true;
        };
    }, [lenderId]);

    return hasLenderIp;
}
